import { cn } from '@/lib/utils';
import type { ReactNode } from 'react';

interface PageScrollProps {
	children: ReactNode;
	contentClassName?: string;
}

interface PageWithHeaderProps {
	header: ReactNode;
	children: ReactNode;
	className?: string;
	contentClassName?: string;
}

export function PageScroll({ children, contentClassName }: PageScrollProps) {
	return (
		<main className='h-full w-full min-h-0 overflow-hidden flex flex-col'>
			<div
				className='flex-1 basis-0 min-h-0 w-full overflow-y-auto overscroll-y-contain touch-scroll'
				data-scroll-container
			>
				<div className={cn('min-h-min w-full', contentClassName)}>{children}</div>
			</div>
		</main>
	);
}

export function PageWithHeader({ header, children, className, contentClassName }: PageWithHeaderProps) {
	return (
		<main className={cn('h-full w-full min-h-0 flex flex-col overflow-hidden', className)}>
			<div className='shrink-0 w-full'>{header}</div>
			<div
				className='flex-1 basis-0 min-h-0 w-full overflow-y-auto overscroll-y-contain touch-scroll'
				data-scroll-container
			>
				<div className={cn('min-h-min w-full flex flex-col gap-3 p-2', contentClassName)}>{children}</div>
			</div>
		</main>
	);
}
